<template>
    <div id="xsdc">
        <headTop :id="id" @topback="topback"></headTop>
        <detailTop :name="name" :text="text" :detailid="detailid"></detailTop>
        <detailBread :breadName="breadName"></detailBread>
        <div class="wsbxContent">
            <div class="wsbxContent_">
                <div class="wsbxContent_1 clearfix">
                    <div class="left">
                        <h3><span>丰富便捷</span> <i class="wsbxh2"></i></h3>
                        <div class="left_text">
                            <h3>菜品丰富多样：</h3>
                            <p>标准套餐、净菜、饮品、年货等预定</p>
                            <h3>多终端</h3>
                            <p>PC端、手机端，方便快捷</p>
                        </div>
                    </div>
                    <div class="right"></div>
                </div>
                <div class="wsbxContent_2">
                    <div class="left"></div>
                    <div class="right">
                        <h3><span>支持多种订餐类型</span> <i class="xsdch2"></i></h3>
                        <div class="left_text">
                            <h3>单位订餐：</h3>
                            <p>内部转账单结算</p>
                            <h3>个人订餐：</h3>
                            <p>校园卡支付</p>
                        </div>
                    </div>
                </div>
                <div class="wsbxContent_3">
                    <div class="left">
                        <h3><span>支持多种订餐类型</span> <i class="xsdch2"></i></h3>
                        <div class="left_text">
                            餐厅及菜品自定义添加 <br>
                            备餐时间、配送时间灵活配置<br>
                            开放对象及订餐类型可选<br>
                            结算报表可一键导出
                        </div>
                    </div>
                    <div class="right"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '线上订餐系统', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '线上订餐系统'
        },
        {
            name: 'description',
            content: '线上订餐系统'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'1',
            detailid:1,
            name:'线上订餐系统',
            text:'线上订餐系统，为高校师生提供食堂菜品的线上订餐及配送服务，实现单位订餐的内部转账单结算以及个人订餐的校园卡支付，提高饮食中心的服务效率和服务质量',
            breadName:'线上订餐系统'
        }
    },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>


// WEBPACK FOOTER //
// src/pages/xsdc.vue